import { createApp, defineAsyncComponent } from 'vue';
import './c-shortcuts.scss';

const BAShortcuts = document.querySelectorAll("[data-feature='BAShortcuts']");

BAShortcuts.forEach((shortcuts) => {
	const elements: NodeList = shortcuts.querySelectorAll(
		'[data-video-button-play]'
	);
	if (elements.length) {
		elements.forEach((element) => {
			const htmlElement: HTMLElement = element as HTMLElement;
			const app = createApp({
				name: htmlElement?.dataset?.blockName,
			});
			app.component(
				'video-button-play',
				defineAsyncComponent(
					() => import('shared/components/VideoCarouselBlock/VideoButtonPlay.vue')
				)
			);
			app.mount(htmlElement);
		});
	}
});